import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { CustomFormControl, CustomFormSelect } from '../../../../StyledComponents';
import { Options } from '../SelectOptions';
import { parse } from 'date-fns/parse'
import { isDate } from 'date-fns/fp'

function parseDateString(value, originalValue) {
    const parsedDate = isDate(originalValue) || originalValue == null
        ? originalValue
        : parse(originalValue, "yyyy-MM-dd", new Date());

    return parsedDate;
}
const today = new Date();

export const Schema = (settings) => Yup.object().shape({
    dateOfBirth: Yup.date()
        .typeError("Bitte geben Sie einen gültigen Wert an")
        .required("Angabe ist erforderlich")
        .min(new Date(1900, 1, 1), "Geburtsdatum muss größer als 01.01.1900 sein.")
        .transform(parseDateString).max(today, "Geburtsdatum kann nicht in der Zukunft liegen")
});

export const DateOfBirthMandatorySubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formDateOfBirth">
                <Form.Label>Geburtsdatum*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Geburtsdatum eingeben"
                    type="date"
                    name="dateOfBirth"
                    value={values.dateOfBirth}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.dateOfBirth && !errors.dateOfBirth}
                    isInvalid={touched.dateOfBirth && errors.dateOfBirth}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.dateOfBirth}
                </Form.Control.Feedback>
            </Form.Group>

        </>
    );
};